import { USER_MODEL_KEY } from 'models/daos/user/constants'
import { toIntegerFormatterUtil } from 'models/formatters/utils'

const USER_BEFORE_UPDATE_HOOK = {
  [USER_MODEL_KEY.GENDER]: toIntegerFormatterUtil,
  [USER_MODEL_KEY.HEIGHT_UNIT]: toIntegerFormatterUtil,
  [USER_MODEL_KEY.WEIGHT_UNIT]: toIntegerFormatterUtil
}

export {
  USER_BEFORE_UPDATE_HOOK
}
